import { BASE_PATH } from '../__mocks__/api';

export const doLogout = async () => {
    let fetchUrl = BASE_PATH + '/logout';
  
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
      },
    };
  
    const result = await fetch(fetchUrl, requestOptions);
    return result;
  }
